import { tv } from 'tailwind-variants'

export const infoCardVariants = tv({
  slots: {
    container: 'flex flex-col my-mili',
    bubble: 'bg-warning-xlight p-mili rounded-mili w-full text-center text-base text-orange'
  }
})
